import { t } from "i18next";

export const getDataTableConfig = () => {
  return [
      { columnid: 'timeSave', title: t("TS_core:MessageSaveTime") },
      { columnid: 'direction', title: t("TS_core:Direction") },
      { columnid: 'sendByFullName', title: t("TS_core:RequestedBy") },
      { columnid: 'action', title: t("TS_core:Action") }
    ];
}